export default {
  jivoLoaded: false,

  init() {
    if (!this.jivoLoaded) {
        window.jivo_onLoadCallback = () => {
          if (!this.jivoLoaded) {  // Добавляем проверку, чтобы выполнить код только один раз
            this.jivoLoaded = true;  // Устанавливаем флаг, что JivoSite загружен
            this.checkUrl();  // Проверяем URL после загрузки JivoSite
          }
        };
      }
  },

  // Показать элементы JivoSite
    showJivoSite() {
      if (this.jivoLoaded) {
        window.jivo_init();  // Показываем виджет
      }
    },

    // Скрыть элементы JivoSite
    hideJivoSite() {
      if (this.jivoLoaded) {
        window.jivo_destroy();  // Удаляем виджет
      }
    },

  checkUrl() {
    const currentUrl = window.location.href;
    if (currentUrl.includes('my-progress')) {
      this.hideJivoSite();
    } else {
      this.showJivoSite();
    }
  }
};



// WEBPACK FOOTER //
// ./Content/src/jivoService.js